import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import './navbar.css'
import firebase from '../../config/Firebase'
import { connect } from 'react-redux';
const activeStyle = {
    backgroundColor: '#34495e',
    color: 'white'
}

class Navbar extends Component {

    handleLogout = () => {
        firebase.auth().signOut()
    }

    render() {
        return (
            <>
                <header className="header" >
                    <div className="header-inner">
                        <div className="logo">
                            <NavLink to="/">
                                <img src="https://theme.hstatic.net/1000239816/1000467243/14/logo.png?v=186" alt="" />
                            </NavLink>
                        </div>
                        <ul className="menu">
                            <li className="menu-item">
                                <NavLink to="/" exact
                                    activeStyle={activeStyle}
                                    className="menu-link"
                                >Home</NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink
                                    to="/products"
                                    activeStyle={activeStyle}
                                    className="menu-link"
                                >Products</NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink
                                    to="/orders"
                                    activeStyle={activeStyle}
                                    className="menu-link"
                                >Orders</NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink
                                    to="/blogs"
                                    activeStyle={activeStyle}
                                    className="menu-link"
                                >Blog</NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink
                                    to="/comments"
                                    activeStyle={activeStyle}
                                    className="menu-link"
                                >Comments</NavLink>
                            </li>
                            {this.props.currentUser ? (
                                <li className="menu-item">
                                    <button
                                        className="logout-btn"
                                        onClick={this.handleLogout}
                                    >Logout</button>
                                </li>
                            ) : (
                                    <>
                                        <li className="menu-item">
                                            <NavLink
                                                to="/login"
                                                activeStyle={activeStyle}
                                                className="menu-link"
                                            >Login</NavLink>
                                        </li>
                                        <li className="menu-item">
                                            <NavLink
                                                to="/register"
                                                activeStyle={activeStyle}
                                                className="menu-link"
                                            >Register</NavLink>
                                        </li>
                                    </>
                                )}
                        </ul>
                    </div>
                </header>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.user.currentUser
    }
}

export default connect(mapStateToProps, null)(Navbar);
